import type { PriceChangeItems, SubmitPriceChangeItemInput } from "@/graphql/codegen/graphql"
import type { PricingGridRow } from "@/screens/Pricing/components/tables/types"
import type { WarehouseHeaderFormValues } from "@/screens/Pricing/schema/WarehouseHeaderSchema"

export const toPriceChangeSubmitItems = (
  rows: PricingGridRow[],
  priceChangeItems: PriceChangeItems,
  uomId: string,
  warehouseValues?: WarehouseHeaderFormValues
): SubmitPriceChangeItemInput[] =>
  rows.map((row) => ({
    productId: priceChangeItems.product.productId,
    customerId: row.item.customerId,
    qty: row.qty,
    price: row.newPrice ?? row.price,
    uom: uomId,
    freightTerms: row.item.freightTerms ?? undefined,
    shipToLocation: row.item.shipToLocationId ?? undefined,
    shipFromWarehouseAreaId: priceChangeItems.shipFromWarehouseArea?.warehouseAreaId ?? "",
    effectiveDate: row.item.effectiveDate ?? undefined,
    expirationDate: row.item.expirationDate ?? undefined,
    acceptedCost: row.acceptedCost ?? undefined,
    incoterms: warehouseValues?.newIncoterms ?? priceChangeItems.incoterms ?? "",
    incotermsLocationId: warehouseValues?.newIncotermsLocation ?? priceChangeItems.incotermsLocationId ?? "",
    surcharge1Price: row.surcharge1Price ?? undefined,
    surcharge1Description: row.surcharge1Description ?? undefined,
    surcharge2Price: row.surcharge2Price ?? undefined,
    surcharge2Description: row.surcharge2Description ?? undefined,
    surcharge3Price: row.surcharge3Price ?? undefined,
    surcharge3Description: row.surcharge3Description ?? undefined,
  }))
